module.exports = __webpack_public_path__ + "img/lines_element.0ebe5bbf.svg";